import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidePanelStateService } from 'app/services/side-panel/side-panel-state.service';
import { SidebarService } from 'app/services/sidebar/sidebar.service';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent implements OnInit {
  @Input() title!: string;
  private sidebarService: SidebarService = inject(SidebarService);
  private sidePanelStateService: SidePanelStateService = inject(SidePanelStateService);
  private destroyRef: DestroyRef = inject(DestroyRef);

  sidebarCollapsed!: boolean;
  sidePanelExpanded!: boolean;

  ngOnInit() {
    this.sidebarService.sidebarCollapsed$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((collapsed) => {
        this.sidebarCollapsed = collapsed;
      });

    this.sidePanelStateService.sidePanelExpanded$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((expanded) => {
        this.sidePanelExpanded = expanded;
      });
  }
}
